if (!customElements.get('g-product-details-tabs')) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();

      this.tabs = new GkifyTheme.Tabs(this, (target) => {
        const index = (target && Number(target.dataset.index)) || 0;
        this.activeTab(index);
      });

      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);
          this.activeTab(index);
        });
      }
    }

    connectedCallback() {
      this.activeTab(0);

      // -----------------------------
      // 🟦 新增功能：如果 URL 带 #review
      // 自动打开第二个 Tab (index = 1)
      // -----------------------------
      if (window.location.hash === '#review') {
        const reviewIndex = 1; // 第二个 tab → index=1

        // 切换到对应 tab
        this.tabs && this.tabs.setActiveTab(reviewIndex);
        this.activeTab(reviewIndex);

        // 滚动到 tabs header（模拟锚点）
        const header = document.querySelector('.g-tabs__header');
        if (header) {
          header.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }

      // --- 评论数量复制 ---
      let text = document.querySelector('#opinew-stars-plugin-product .opinew-no-reviews-stars-plugin')?.textContent;
      if (!text) return;
      let number = text.match(/\d+/) || 0;
      document.querySelector('.js_reviews_number').textContent = `(${number})`;
    }

    activeTab(index) {
      //隐藏非index
      let len = this.tabs.domNodes?.tabHeaders.length;
      if (len === 0) return;

      this.tabs.domNodes?.tabHeaders?.forEach((dom, i) => {
        document.querySelectorAll(`.js_tab_${i + 1}`).forEach((dom) => {
          dom.classList.add('g:hidden');
        });
      });

      document.querySelectorAll(`.js_tab_${index + 1}`).forEach((dom) => {
        dom.classList.remove('g:hidden');
      });
    }
  }

  customElements.define('g-product-details-tabs', MProductDetailsTabs);
}
